var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-navbar"},[_c('ContainerInner',{staticClass:"header-navbar__inner"},[(_vm.isDesktop)?_c('ElementBrand',{staticClass:"header-navbar__brand"}):_vm._e(),(!_vm.isDesktop)?_c('TheSearch',{staticClass:"header-navbar__search"}):_vm._e(),_c('TheMenu',{staticClass:"header-navbar__menu"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }